/**
 * WriteoffSlice State Definition
 * 
 * Defines the state interface and initial state for the writeoff slice.
 */

import { WriteoffView } from '../types';

/**
 * State interface for the writeoff slice.
 * Follows the standard BaseSliceState pattern with writeoff-specific naming.
 */
export interface WriteoffSliceState {
  /** The current writeoff being viewed/edited, or null if none selected */
  currentWriteoff: WriteoffView | null;
  /** Whether any edits have been made since loading/saving */
  isEdited: boolean;
  /** List of field names that have been modified */
  editedFields: string[];
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
}

/**
 * Initial state for the writeoff slice.
 */
export const initialState: WriteoffSliceState = {
  currentWriteoff: null,
  isEdited: false,
  editedFields: [],
  validationErrors: {},
};
